export enum ClaimType {
  Primary = 0,
  Collaboration = 1,
}
